/** Schema display names that require the user to confirm a report_type before mapping. */
export const REQUIRED_REPORT_TYPE_SCHEMAS = ["Lloyds Coverholder Reporting Standard"] as const;

export function schemaRequiresReportType(schemaName: string): boolean {
  return (REQUIRED_REPORT_TYPE_SCHEMAS as readonly string[]).includes(schemaName);
}
